import {
  Box,
  Divider,
  Flex,
  Image,
  MediaBox,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

const ItemContainer = styled(Flex).attrs({
  py: 2,
})``

const ImageWrapper = styled(Box)`
  border: 1px solid ${(props) => props.theme.colors.grey[20]};
  height: 88px;
  margin-right: 10px;
  width: 88px;
  ${(props) => props.theme.mediaQueries.tablet`
    height: 186px;
    margin-right: 32px;
    width: 186px;
  `}
`

const LineItem = ({ item }) => {
  const line_item_addons = (item.addons || []).map((addon) => (
    <Flex alignItems="center" key={addon.id} mb={{ tablet: "12px" }}>
      <Image
        alt={addon.title}
        mr={{ _: "12px", tablet: 1 }}
        ratio="1 / 1"
        src={addon.image_url}
        width={{ _: "52px", tablet: "70px" }}
      />
      <Typography
        fontSize="16px"
        fontWeight="300"
        letterSpacing="-0.02em"
        lineHeight="22px"
      >
        {addon.title}
      </Typography>
    </Flex>
  ))

  return (
    <>
      <ItemContainer>
        <ImageWrapper>
          <Image
            alt={item.title}
            ratio="1 / 1"
            src={item.image_url}
            width={{ _: "88px", tablet: "186px" }}
          />
        </ImageWrapper>
        <Flex flex="1" justifyContent="space-between">
          <Box>
            <Typography
              fontSize={{ _: "16px", tablet: "20px" }}
              fontWeight="500"
              letterSpacing="-0.02em"
              lineHeight={{ _: "20px", tablet: "24px" }}
              mb="12px"
            >
              {item.title}
            </Typography>
            {item.addons && (
              <MediaBox greaterThanOrEqual="tablet">
                {line_item_addons}
              </MediaBox>
            )}
          </Box>
          {item.addon_type === "GIFT" && (
            <Typography
              fontSize={{ _: "14px", tablet: "20px" }}
              fontWeight={{ _: "700", tablet: "500" }}
              lineHeight={{ _: "18px", tablet: "24px" }}
              ml={2}
            >
              FREE GIFT
            </Typography>
          )}
        </Flex>
      </ItemContainer>
      {item.addons && <MediaBox lessThan="tablet">{line_item_addons}</MediaBox>}
      <Divider bg="grey.20" my={2} />
    </>
  )
}

LineItem.propTypes = {
  item: PropTypes.object,
}

export default LineItem
